const variableTypes = {
  NUMBER: "NUMBER",
  BOOLEAN: "BOOLEAN",
  STRING: "STRING",
  DATE: "DATE",
  TIME: "TIME",
  DATETIME: "DATETIME",
  UUID: "UUID",
  EXPRESSION: "EXPRESSION"
};

export {
  variableTypes
};


// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/selection-contorl/constants.js